<template>
	<div class="card__container">
		<div class="card__heading">
			<div class="card__icon" :class="['service-icon', iconName]"></div>
			<div class="card__name">{{ serviceName }}</div>
			<div class="card__total">
				<span class="card__total-txt">Total </span>$ {{ serviceTotal }}
			</div>
		</div>
		<div class="card__body">
			<Metric
				v-for="(metric, index) in metrics"
				:fr="metricFr(index)"
				:metric="metric"
				:key="index"
				:allMetrics="allMetrics"
			/>
		</div>
	</div>
</template>

<script>
import Metric from './Metric';
export default {
	name: 'UsageCard',
	components: {
		Metric,
	},
	props: ['service', 'allMetrics'],
	computed: {
		iconName: function () {
			return this.service.service.name.toLowerCase() + '-icon';
		},
		serviceName: function () {
			return this.service.service.name;
		},
		serviceTotal: function () {
			return (this.service.totalCents / 100).toFixed(2);
		},
		metrics: function () {
			var list = this.service.metrics || [];
			if (this.allMetrics) {
				return list;
			}
			return list.filter((m) =>
				m.usage ? m.usage.find((u) => u.pricing) : false,
			);
		},
	},
	methods: {
		metricFr(index) {
			var ln = this.metrics.length;
			if (ln > 2) {
				return 1;
			} else if (ln == 2) {
				return 2 - index;
			} else {
				return 3;
			}
		},
	},
};
</script>

<style>
.light .card__container {
	border: 1px solid #d8d8d8;
}
.dark .card__container {
	border: 1px solid #4d4b4b;
}
.light .card__name {
	color: #c78500;
}
.dark .card__name {
	color: #ffb536;
}
.light .card__total,
.light .card__total-txt {
	color: #212529;
}
.dark .card__total,
.dark .card__total-txt {
	color: #fafafa;
}
.card__container {
	margin-top: 24px;
	padding: 25px;
}
.card__heading {
	display: flex;
	align-items: center;
	border-radius: 2px;
}
.card__icon {
	width: 24px;
	height: 24px;
	margin-right: 10px;
}
.card__name {
	font-family: Corbel, sans-serif;
	font-size: 20px;
}
.card__total {
	display: flex;
	align-items: center;
	margin-left: auto;
	font-size: 22px;
}
.card__total-txt {
	font-size: 16px;
	margin-right: 19px;
}
.card__body {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 24px;
	margin-top: 24px;
}
</style>